import React, { useEffect, useState } from "react";
import HeaderBar from "../../../../components/header/headerBar";
import Input from "../../../../components/textfield/input";
import MainButton from "../../../../components/button/mainButton";
import Select from "../../../../components/select/selectField";
import Textarea from "../../../../components/textfield/textarea";
import { useParams } from "react-router-dom";
import CheckboxText from "../../../../components/textfield/checkbox";
import "../../../../assets/styles/admin/stock.scss";

interface ParamsType {
  id: string;
}

const StockCreateProduct = () => {
  const { id } = useParams<ParamsType>();
  const [branch, setBranch] = useState<string>("");
  const [wareHouse, setWareHouse] = useState<string>("");
  const [typeOrder, setTypeOrder] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [bigUnits, setBigUnits] = useState<string>("");
  const [subUnit, setSubUnit] = useState<string>("");
  const [amountPer, setAmountPer] = useState<string>("");
  const [pricePerUnit, setPricePerUnit] = useState<string>("");
  const [expirationDate, setExpirationDate] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [codeOrder, setCodeOrder] = useState<string>("");
  const [remainingAlert, setRemainingAlert] = useState<string>("");
  const [notifiExpire, setNotifiExpire] = useState<string>("");
  const [amountSubUnit, setAmountSubUnit] = useState<string>("");

  const option = [
    { value: "เอกมัย", name: "เอกมัย สำนักงานใหญ่" },
    { value: "ชิดลม", name: "ชิดลม" },
    { value: "คริสตัล", name: "คริสตัล ดีไซน์ เซ็นเตอร์" },
  ];
  const warehouse = [
    { value: "ห้องยา", name: "ห้องยา" },
    { value: "ห้องAnti", name: "ห้องAnti" },
    { value: "คลินิก", name: "คลินิก" },
    { value: "Aesthetic", name: "Aesthetic" },
    { value: "Treatment", name: "Treatment" },
    { value: "Hair", name: "Hair" },
    { value: "ชิดลม", name: "ชิดลม" },
    { value: "ซีดีซี", name: "ซีดีซี" },
    { value: "การตลาด", name: "การตลาด" },
  ];
  const productType = [
    { value: "FG", name: "FG" },
    { value: "MA", name: "MA" },
    { value: "RA", name: "RA" },
    { value: "PK", name: "PK" },
    { value: "RM", name: "RM" },
    { value: "SP", name: "SP" },
  ];
  const bigUnit = [
    { value: "แพ็ค", name: "แพ็ค" },
    { value: "ลัง", name: "ลัง" },
  ];
  const subunits = [
    { value: "ชิ้น", name: "ชิ้น" },
    { value: "ช๊อต", name: "ช๊อต" },
    { value: "กล่อง", name: "กล่อง" },
    { value: "หลอด", name: "หลอด" },
  ];

  const createData = () => {};

  const updateData = (id: string) => {};

  useEffect(() => {}, []);

  return (
    <div>
      <HeaderBar title="STOCK / CREATE PRODUCT" btnBack={true} />
      <div style={{ margin: "0px 40px" }}>
        <div className="create-page" style={{ padding: "20px 40px" }}>
          <div className="title-header">
            <h3 style={{ fontSize: "20px" }}>เพิ่มสินค้าใหม่</h3>
          </div>
          <div className="row justify-content-around">
            <div className="row col-4">
              <Select
                className="col-10"
                title="สาขา"
                option={option}
                value={branch}
                onChange={(e) => {
                  setBranch(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Select
                className="col-10"
                title="คลังสินค้า"
                option={warehouse}
                value={wareHouse}
                onChange={(e) => {
                  setWareHouse(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Select
                className="col-4"
                title="ประเภทสินค้า"
                option={productType}
                value={typeOrder}
                onChange={(e) => {
                  setTypeOrder(e.target.value);
                }}
              />
              <Input
                className="col-7"
                title="รหัสสินค้า"
                type="text"
                placeholder=""
                value={codeOrder}
                onChange={(e) => {
                  setCodeOrder(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="row justify-content-around">
            <div className="row col-4">
              <Input
                className="col-10"
                title="ชื่อ"
                type="text"
                placeholder=""
                value={userName}
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Input
                className="col-10"
                title="วันหมดอายุ"
                type="date"
                placeholder=""
                value={expirationDate}
                onChange={(e) => {
                  setExpirationDate(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <CheckboxText className="col-1 check-boked" />
              <Input
                className="col-10"
                title="แจ้งเตือนก่อนหมดอายุ (วัน)"
                type="text"
                placeholder=""
                value={notifiExpire}
                onChange={(e) => {
                  setNotifiExpire(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="row justify-content-around">
            <div className="row col-4">
              <Select
                className="col-10"
                title="หน่วยใหญ่"
                option={bigUnit}
                value={bigUnits}
                onChange={(e) => {
                  setBigUnits(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Input
                className="col-10"
                title="จำนวนต่อหน่วยใหญ่"
                type="text"
                placeholder=""
                value={amountPer}
                onChange={(e) => {
                  setAmountPer(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Select
                className="col-11"
                title="หน่วยย่อย"
                option={subunits}
                value={subUnit}
                onChange={(e) => {
                  setSubUnit(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Input
                className="col-10"
                title="จำนวนทั้งหมดต่อหน่วยย่อย"
                type="text"
                placeholder=""
                value={amountSubUnit}
                onChange={(e) => {
                  setAmountSubUnit(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <Input
                className="col-10"
                title="ราคาต่อหน่วยย่อย"
                type="text"
                placeholder=""
                value={pricePerUnit}
                onChange={(e) => {
                  setPricePerUnit(e.target.value);
                }}
              />
            </div>
            <div className="row col-4">
              <CheckboxText className="col-1 check-boked" />
              <Input
                className="col-10"
                title="แจ้งเตือนเมื่อเหลือ (จำนวน/หน่วยย่อย)"
                type="text"
                placeholder=""
                value={remainingAlert}
                onChange={(e) => {
                  setRemainingAlert(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="row justify-content-around">
            <div className="row">
              <Textarea
                title="รายละเอียด"
                placeholder=""
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="justify-center mt-20">
        <MainButton className="mg-10" background="#E76464" title="ยกเลิก" />
        <MainButton
          className="mg-10"
          title="บันทึกข้อมูล"
          onClick={() => {
            id ? updateData(id) : createData();
          }}
        />
      </div>
    </div>
  );
};
export default StockCreateProduct;
